'use client';

import { __makeTemplateObject } from '../_virtual/_tslib.js';
import styled from 'styled-components';

var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var customEnable = _a.customEnable;
    return !customEnable
        ? "\n    background-color: #fff;\n    border: 1px solid #005aff;\n    border-radius: 10px;\n    overflow: hidden;\n    "
        : '';
});
var Header = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var customEnable = _a.customEnable;
    return !customEnable
        ? "\n    display: grid;\n    grid-template-columns: 1fr auto;\n    background-color: #005aff;\n    align-items: center;\n    "
        : '';
});
var HeaderContent = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    cursor: ", ";\n"], ["\n    cursor: ", ";\n"])), function (_a) {
    var customContent = _a.customContent;
    return (customContent ? 'auto' : 'pointer');
});
var CollapsibleContent = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    transition: max-height 0.25s ease-in-out, opacity 0.2s ease-out;\n    ", "\n"], ["\n    transition: max-height 0.25s ease-in-out, opacity 0.2s ease-out;\n    ", "\n"])), function (_a) {
    var enableMaskImage = _a.enableMaskImage, isCollapse = _a.isCollapse;
    return enableMaskImage && isCollapse ? 'mask-image: linear-gradient(180deg, #fff, transparent);' : '';
});
var Content = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    line-height: 20px;\n    font-size: 14px;\n    font-weight: 400;\n"], ["\n    line-height: 20px;\n    font-size: 14px;\n    font-weight: 400;\n"])));
var IconWrapper = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    display: flex;\n    cursor: pointer;\n    transition: transform 0.25s ease-in-out;\n    transform: rotate(", "deg);\n"], ["\n    display: flex;\n    cursor: pointer;\n    transition: transform 0.25s ease-in-out;\n    transform: rotate(", "deg);\n"])), function (_a) {
    var isCollapse = _a.isCollapse;
    return (isCollapse ? '0' : '180');
});
var ViewMoreButton = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    cursor: pointer;\n    width: fit-content;\n"], ["\n    cursor: pointer;\n    width: fit-content;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;

export { CollapsibleContent, Container, Content, Header, HeaderContent, IconWrapper, ViewMoreButton };
//# sourceMappingURL=Collapse.css.js.map
